export default "__VITE_ASSET__DpIxhdmK__"